import React from "react";

import PropTypes from "prop-types";
import { useIntl } from "react-intl";

import Checkbox from "ds/Checkbox";
import useMediaQuery from "Hooks/useMediaQuery";

import * as S from "../EnvironmentGeneralSettings.styles";

const EmailSetting = ({ environment, enable_smtp, onEmailSendingChange }) => {
  const intl = useIntl();
  const onMobile = useMediaQuery("(max-width: 768px)");

  return (
    <>
      <S.SettingWrapper>
        <S.EmailSettingsWrapper>
          <Checkbox
            label={intl.formatMessage(
              {
                id: onMobile ? "email_sending.title" : "email_sending"
              },
              {
                b: (...chunks) => <strong>{chunks}</strong>
              }
            )}
            id={onMobile ? "email_sending.title" : "email_sending"}
            checked={enable_smtp}
            onCheckedChanged={onEmailSendingChange}
            disabled={
              !(environment.hasPermission && environment.hasPermission("#edit"))
            }
            aria-disabled={
              !(environment.hasPermission && environment.hasPermission("#edit"))
            }
            forId="environment-is-sending-email-switch"
          />{" "}
          {onMobile && (
            <S.HttpsBodyText>
              {intl.formatMessage({ id: "email_sending.description" })}
            </S.HttpsBodyText>
          )}
        </S.EmailSettingsWrapper>
      </S.SettingWrapper>
    </>
  );
};

EmailSetting.propTypes = {
  environment: PropTypes.object,
  enable_smtp: PropTypes.bool,
  onEmailSendingChange: PropTypes.func
};

export default EmailSetting;
